// Pure date helpers for the video-lectures listing. No DOM, no network — unit-tested.

function pad2(n) {
  return String(n).padStart(2, "0");
}

// Machine key for a row: the local calendar date as YYYY-MM-DD. It groups the
// feed, so it must stay in that format — render it through formatDateLabel,
// never straight to the page.
export function formatDateKeyLocal(isoOrDate) {
  const d = new Date(isoOrDate);
  if (Number.isNaN(d.getTime())) return "";
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
}

// YouTube-like heading for a date key (local viewer time).
export function formatDateLabel(dateKey) {
  // Bare YYYY-MM-DD parses as UTC; the time suffix keeps it local so the
  // heading matches the key the row was grouped under.
  const d = new Date(`${dateKey}T00:00:00`);
  if (Number.isNaN(d.getTime())) return dateKey;
  return d.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: d.getFullYear() === new Date().getFullYear() ? undefined : "numeric",
  });
}
